"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStorageAvailable = void 0;
/**
 * Function for feature detecting browser storage
 * (taken from https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage)
 *
 * @param { StorageType } type the storage mechanism you are checking for
 * @returns { boolean }
 */
function isStorageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.isStorageAvailable = isStorageAvailable;
//# sourceMappingURL=storage.js.map